import { pathJoin } from 'utils/general';
import { getBreadcrumbs } from 'redux/modules/search-and-browse/selectors/get-breadcrumbs';
import { offerCategorySegment } from 'redux/modules/taxonomy/selectors/offers';

const isPath = path => path.indexOf('/') === 0;

const offerCategoryCrumbPath = ({ path, prevPath }, state) =>
  pathJoin(prevPath, `${offerCategorySegment(state, path)}`);

const generateOffersBreadCrumbs = state => {
  let prevPath = '';
  const breadcrumbs = getBreadcrumbs(state);

  if (!breadcrumbs) return breadcrumbs;

  return breadcrumbs.map(crumb => {
    const { name, path = '' } = crumb;
    const havePath = isPath(path);
    const mappedCrumb = {
      name,
      path: havePath ? path : offerCategoryCrumbPath({ path, prevPath }, state),
    };

    prevPath = mappedCrumb.path;

    if (!havePath) {
      const categoryId = { categoryId: path };
      const searchParams = new URLSearchParams(categoryId);
      return {
        ...mappedCrumb,
        path: `${mappedCrumb.path}?${searchParams.toString()}`,
        search: categoryId,
      };
    }

    return mappedCrumb;
  });
};

export default generateOffersBreadCrumbs;
